import { Image } from 'expo-image';
import { useEffect } from 'react';
import { StyleSheet, useWindowDimensions, View } from 'react-native';
import Animated, {
  FadeInDown,
  FlipInYLeft,
  FlipInYRight,
  useAnimatedStyle,
  useSharedValue,
  withDelay,
  withTiming
} from 'react-native-reanimated';

import { broken, shepherds, urn } from '@/assets/images';

import DotsLoader from '../DotsLoader';

const SplashScreenWeb = () => {
  const { width } = useWindowDimensions();

  const logoHeight = width >= 1024 ? 150 : width >= 768 ? 135 : width >= 425 ? 120 : 100;
  const textHeight = width >= 1024 ? 50 : width >= 768 ? 40 : width >= 425 ? 35 : 30;
  const dotsSize = width >= 1024 ? 10 : width >= 768 ? 9 : width >= 425 ? 8 : 7;

  const opacity = useSharedValue(0);

  const animatedOpacityStyle = useAnimatedStyle(() => {
    return {
      opacity: withDelay(
        700,
        withTiming(opacity.value, {
          duration: 500
        })
      )
    };
  });

  useEffect(() => {
    opacity.value = 1;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <View style={styles.mainContainer}>
      <View style={styles.logoContainer}>
        <Animated.View
          style={[{ height: logoHeight }, animatedOpacityStyle]}
          entering={FadeInDown.duration(650).delay(650)}>
          <Image cachePolicy={'memory'} contentFit="contain" source={urn} style={styles.logo} />
        </Animated.View>
        <Animated.View style={{ height: textHeight }} entering={FlipInYRight.duration(650)}>
          <Image cachePolicy={'memory'} contentFit="contain" source={broken} style={styles.logo} />
        </Animated.View>
        <Animated.View style={{ height: textHeight }} entering={FlipInYLeft.duration(650)}>
          <Image cachePolicy={'memory'} contentFit="contain" source={shepherds} style={styles.logo} />
        </Animated.View>
      </View>

      <Animated.View style={animatedOpacityStyle}>
        <DotsLoader color="white" size={dotsSize} />
      </Animated.View>
    </View>
  );
};

const styles = StyleSheet.create({
  mainContainer: {
    flex: 1,
    flexDirection: 'column',
    gap: 50,
    justifyContent: 'center',
    alignItems: 'center',
    height: '100%',
    width: '100%',
    backgroundColor: 'black'
  },

  logoContainer: {
    width: '100%',
    gap: 15
  },

  logo: {
    height: '100%',
    width: '100%'
  },

  loading: {
    fontSize: 24,
    color: 'white',
    textTransform: 'uppercase'
  }
});

export default SplashScreenWeb;
